import css from "styled-jsx/css";

export default css`
  .devices-fake {
    width: 100%;
    margin-left: 0;
    &--title {
      height: 22px;
      width: 20%;
    }
    &--container {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      gap: 1rem;
      margin-bottom: 1rem;
      &--box-container {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #DDDDDD;
        border-radius: 16px;
        padding: 1rem;
        &--column {
          height: 10.5rem;
          display: flex;
          justify-content: space-between;
        }
        &--image {
          height: 100%;
          width: 30%;
          margin: 0 0.5rem;
          border-radius: 8px;
        }
        &--info {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          height: 100%;
          width: 70%;
          &--title {
            height: 24px;
            width: 75%;
          }
          &--text {
            height: 16px;
            width: 90%
          }
        }
      }
      &--box {
        height: 60px;
        width: 100%;
        background-color: #f5f5f5;
        padding: 0.2rem 1rem;
      }
    }
    &--text-footer {
      margin-top: 1rem;
      height: 20px;
      width: 30%;
    }
    &--footer {
      border-radius: 16px;
      height: 150px;
      width: 100%;
      margin-top: 1rem;
    }
  }

  @media (min-width: 768px) {
    .devices-fake {
      width: 70%;
      &--container {
        gap: 1rem;
        &--box-container {
          width: 45%;
          gap: 1rem;
        }
      }
      &--footer {
      width: 20%;
    }
    }
  }
`;
